import { render, staticRenderFns } from "./tableLayoutTd.vue?vue&type=template&id=bc393a56&"
import script from "./tableLayoutTd.vue?vue&type=script&lang=js&"
export * from "./tableLayoutTd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports